
export const LTEActionTypeEnum = {
   DEFAULT: 0,
   VIEW: 0,
   MODIFY: 0,
   DELETED: 1,
   PRINT: 2,
   BOOKING: 3,
   SEND_PDF: 4,
   ADD_RETAIL_SERVICE: 5,
   PAYMENT: 6,
}

export default {
   LTEActionTypeEnum
}


// WEBPACK FOOTER //
// ./src/components/LTEEnum.js